export default __webpack_public_path__ + "static/media/delete-white.d9896184.svg";